import { render, staticRenderFns } from "./DataIncrease.vue?vue&type=template&id=b204c32a&scoped=true&"
import script from "./DataIncrease.vue?vue&type=script&lang=js&"
export * from "./DataIncrease.vue?vue&type=script&lang=js&"
import style0 from "./DataIncrease.vue?vue&type=style&index=0&id=b204c32a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b204c32a",
  null
  
)

export default component.exports